/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
import React from 'react';

import { Fade } from 'react-awesome-reveal';

import Team from 'assets/images/hero/farmers.png';
import { useLanguage } from '../contexts/LanguageContext.js';

export default function HeroTeam() {
  const { t } = useLanguage();

  return (
    <section className="hero sm:items-center lg:items-start sm:flex-row">

      <div className="w-full sm:w-1/2 flex flex-col px-5 mb-5 sm:mb-0 sm:px-12 sm:mt-6 lg:mt-6 xl:mt-20">
        <Fade direction="up" triggerOnce>
          <h1 className="text-6xl text-white font-bold leading-tight mb-5">
            {t('aboutUsTitle')}
          </h1>
        </Fade>
        <Fade direction="up" delay={500} triggerOnce>
          <p className="font-medium text-base text-white leading-relaxed">
            {t('companyDescription')}
          </p>

          <p className="font-medium text-base text-white leading-relaxed mt-4 w-fit">
            {t('fertilizerDescription')}
          </p>
        </Fade>
      </div>
      <div className="flex pt-5 w-full justify-center items-center order-first md:w-full lg:order-last lg:w-1/2">
        <Fade direction="top-right" triggerOnce delay={300}>
          <img src={Team} alt="Hero" />
        </Fade>
      </div>
    </section>
  );
}
